import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ProfileService } from '@app-utils';

export const authGuard: CanActivateFn = (route, state) => {
  const _profile = inject(ProfileService);
  const _router = inject(Router);
  const token = _profile.getToken();

  if (token) {
    return true;
  }
  void _router.navigate(['/auth'], {
    ...(state.url?.split('/')[1]
      ? { queryParams: { returnUrl: state.url } }
      : {}),
  });
  return false;
};
